<div class="profile-container">
  <div class="row">
    <div class="col-md-6">
      <div class="form-section">
        <div class="form-horizontal">
          <!-- Client ID -->
          <div class="form-row">
            <label>Client ID <span class="required">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.customerNo"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Client ID"
              aria-label="Client ID"
            />
          </div>

          <!-- Client Name -->
          <div class="form-row">
            <label>Company Name <span class="required">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.companyName"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Company Name"
              aria-label="Company name"
            />
          </div>

          <!-- Email -->
          <div class="form-row">
            <label>Email</label>
            <input
              type="email"
              class="form-control"
              [(ngModel)]="client.email"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Email"
              aria-label="Email"
            />
          </div>

          <!-- Phone -->
          <div class="form-row">
            <label>Phone</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.phone"
              [disabled]="!isEditMode || !canEdit"
              [inputMask]="phoneMask"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Phone"
              aria-label="Phone"
            />
          </div>

          <!-- Alt Phone -->
          <div class="form-row">
            <label>Alt Phone</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.altPhone"
              [disabled]="!isEditMode || !canEdit"
              [inputMask]="phoneMask"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Alt Phone"
              aria-label="Alt phone"
            />
          </div>

          <!-- Contact Name -->
          <div class="form-row">
            <label>Contact Name</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.contactName"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Contact Name"
              aria-label="Contact name"
            />
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="form-horizontal">
          <!-- Payment Terms / Billing Range -->
          <div class="form-row">
            <label>Payment Terms (Days)</label>
            <input
              type="number"
              class="form-control"
              [(ngModel)]="client.billingRange"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Payment Terms"
              aria-label="Payment terms in days"
            />
          </div>

          <!-- Valid From -->
          <div class="form-row">
            <label>Valid From <span class="required">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.validFrom"
              [disabled]="!isEditMode || !canEdit"
              [inputMask]="dateInputMask"
              placeholder="MM/DD/YY"
              autocomplete="off"
              aria-label="Valid from date"
            />
          </div>

          <!-- Valid To -->
          <div class="form-row">
            <label>Valid To</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.validTo"
              [disabled]="!isEditMode || !canEdit"
              [inputMask]="dateInputMask"
              placeholder="MM/DD/YY"
              autocomplete="off"
              aria-label="Valid to date"
            />
          </div>

          <!-- Has Plant Number -->
          <div class="form-row checkbox-row">
            <label>Has Plant Number</label>
            <input
              type="checkbox"
              [(ngModel)]="client.hasPlantNumber"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              aria-label="Has plant number"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-section">
        <div class="form-horizontal">
          <!-- Address -->
          <div class="form-row">
            <label>Address <span class="required">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.address"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Address"
              aria-label="Address"
            />
          </div>

          <!-- Address 2 -->
          <div class="form-row">
            <label>Address 2</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.address2"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Address 2"
              aria-label="Address 2"
            />
          </div>

          <!-- City -->
          <div class="form-row">
            <label>City <span class="required">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.city"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter City"
              aria-label="City"
            />
          </div>

          <!-- State -->
          <div class="form-row">
            <label>State <span class="required">*</span></label>
            <select
              class="form-control"
              [(ngModel)]="client.state"
              [disabled]="!isEditMode || !canEdit"
              (ngModelChange)="onFieldChange()"
              aria-label="State"
            >
              <option [ngValue]="null">Select State</option>
              <option *ngFor="let state of states" [value]="state.abbreviation">
                {{ state.fullName }}
              </option>
            </select>
          </div>

          <!-- Zip -->
          <div class="form-row">
            <label>Zip <span class="required">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="client.zip"
              [disabled]="!isEditMode || !canEdit"
              [inputMask]="zipMask"
              (ngModelChange)="onFieldChange()"
              placeholder="Enter Zip"
              aria-label="Zip code"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
